/**
 * front-pageでつかわれる
 */

import { BREAKPOINTS } from "./constants/breakpoints";
import debounce from 'lodash.debounce';

export default class FrontPage {
   constructor() {
      this.$window = $(window);
      this.windowWidth = window.innerWidth; // ブラウザのスクロールバーも含めて横幅を取得
      // this.beforeWidth = this.windowWidth;
      this.$fvSearchform  = $('#fvSearchform');
      // this.$fvSearchPanelTrigger = $('.js-fvSearchPanelTrigger');
      // this.$fvSearchPanelMask = $('.js-fv-search-panel-mask');
      this.$searchConditionSettingDrawerMask = $('[data-search-condition-setting-drawer-mask]');
      // this.$searchConditionSettingDropdownMask = $('[data-search-condition-setting-dropdown-mask]');
      this.currentSearchConditionSettingDrawerId = '';
      // this.currentSearchConditionSettingDropdownId = '';

      this.$window.on('resize', debounce(() => {
         this.windowWidth = window.innerWidth;
      }, 500));

      this.setEventHandlers();

   }

   setEventHandlers() {
      $('[data-search-condition-setting-desktop-ui-form-item]').on('change', (e) => {
         this.onChangeSearchPanelSelect(e)
      });

      // drawer trigger click（賃料・面積/用途業種、moblie/desktopで共通）
      $('[data-search-condition-setting-drawer-trigger]').on('click', (e) => {
         this.onClickSearchConditionSettingDrawerTrigger(e)
      });

      // 賃料と面積の設定ボタン
      $('[data-search-condition-setting-btn]').on('click', (e) => {
         this.onClickSearchConditionSettingDrawerSetBtn(e)
      });
      // 用途業種の設定ボタン
      $('[data-search-condition-setting-btn-for-uses]').on('click', (e) => {
         this.onClickSearchConditionSettingDrawerSetBtnForUses(e)
      });

      // mobile時のdrawer mask clickイベント
      this.$searchConditionSettingDrawerMask.on('click', () => {
         this.onClickSearchConditionSettingDrawerMask()
      });

   }

   onChangeSearchPanelSelect(e) {
      const currentTargetName = $(e.currentTarget).attr('data-search-condition-setting-desktop-ui-form-item');
      this.$fvSearchform.find(`input[type='hidden'][name="${currentTargetName}"]`).val($(e.currentTarget).val());
   }

   onClickSearchConditionSettingDrawerTrigger(e) {
      this.currentSearchConditionSettingDrawerId = $(e.currentTarget).attr('data-search-condition-setting-drawer-trigger');
      // mobile
      if (this.windowWidth < BREAKPOINTS.MEDIUM) {
         $('body').css('overflow', 'hidden')
         this.$searchConditionSettingDrawerMask.show()
         $(`[data-search-condition-setting-drawer-id="${this.currentSearchConditionSettingDrawerId}"]`).css({
            display: 'block',
            transform: 'translateY(0%)',
         });
      } else {
         // desktop
         if (this.currentSearchConditionSettingDrawerId) {
            const $drawer = $(`[data-search-condition-setting-drawer-id-for-desktop="${this.currentSearchConditionSettingDrawerId}"]`);
            // drawerが存在して、かつdrawerが非表示の場合のみ表示処理とイベントハンドラの設定を行う
            if ($drawer.length && $drawer.css('display') === 'none') {
               $drawer.css({
                  display: 'block',
                  opacity: 1,
                  visibility: 'visible',
               });
               $(document).on('click.closeSearchConditionSettingDrawerForDesktop', (event) => {
                  this.setOutDrawerClickHandlerForDesktop();
               });
            }
        }
      }
   }

   // mobile時に呼ばれる
   closeSearchConditionSettingDrawer() {
      $(`[data-search-condition-setting-drawer-id="${this.currentSearchConditionSettingDrawerId}"]`).css({
            display: 'none',
            transform: 'translateY(100%)',
      });
      // TODO: transitionendとかで後続処理したい
      setTimeout(() => {
         this.$searchConditionSettingDrawerMask.hide();
         $('body').css('overflow', 'auto');
      }, 200);
      this.currentSearchConditionSettingDrawerId = '';
   }

   onClickSearchConditionSettingDrawerMask() {
      this.closeSearchConditionSettingDrawer()
   }

   onClickSearchConditionSettingDrawerSetBtn(e) {
      const $parent = $(e.currentTarget).closest('[data-search-condition-setting-drawer-id]');
      const $formItems = $('[data-search-condition-setting-drawer-form-item]', $parent);
      let rentLowerVal = '';
      let rentLowerText = '';
      let rentUpperVal = '';
      let rentUpperText = '';
      let areaSizeLowerVal = '';
      let areaSizeLowerText = '';
      let areaSizeUpperVal = '';
      let areaSizeUpperText = '';
      const checkedOptions = [];
      if ($formItems) {
         $formItems.each((i, el) => {
            const formName = $(el).attr('data-search-condition-setting-drawer-form-item');
            // 賃料と面積のinputフィールドに値を設定（用途業種は別途処理）
            this.$fvSearchform.find(`input[type='hidden'][name="${formName}"]`).val($(el).val());
            if (formName === 'rent_limit_lower') {
               rentLowerVal = $(el).val();
               rentLowerText = rentLowerVal ? $(el).children(':selected').text() : '下限なし';
            } else if (formName === 'rent_limit_upper') {
               rentUpperVal = $(el).val();
               rentUpperText = rentUpperVal ? $(el).children(':selected').text() : '上限なし';
            } else if (formName === 'area_size_limit_lower') {
               areaSizeLowerVal = $(el).val();
               areaSizeLowerText = areaSizeLowerVal ? $(el).children(':selected').text() : '下限なし';
            } else if (formName === 'area_size_limit_upper') {
               areaSizeUpperVal = $(el).val();
               areaSizeUpperText = areaSizeUpperVal ? $(el).children(':selected').text() : '上限なし';
            }
         });

         const rentText = rentLowerVal || rentUpperVal ? `${rentLowerText}〜${rentUpperText}` : '指定なし';
         const areaSizeText = areaSizeLowerVal || areaSizeUpperVal ? `${areaSizeLowerText}〜${areaSizeUpperText}` : '指定なし';

         // UIのテキストを更新
         $('[data-search-condition-setting-text="rent"]').text(rentText);
         $('[data-search-condition-setting-text="areaSize"]').text(areaSizeText);
      }
      // close drawer ui
      if (this.currentSearchConditionSettingDrawerId) {
         this.closeSearchConditionSettingDrawer()
      }
   }

   // desktop UIでdrawer外をクリックしたときのイベントハンドラ
   setOutDrawerClickHandlerForDesktop() {
      $(document).on('click.closeSearchConditionSettingDrawerForDesktop', (event) => {
         if (!$(event.target).closest(`[data-search-condition-setting-drawer-id-for-desktop="${this.currentSearchConditionSettingDrawerId}"]`).length) {
            this.closeSearchConditionSettingDrawerForDesktop();
         }
      });
   }

   // desktop UIでdrawerを閉じる
   closeSearchConditionSettingDrawerForDesktop() {
      if (this.currentSearchConditionSettingDrawerId && $(`[data-search-condition-setting-drawer-id-for-desktop="${this.currentSearchConditionSettingDrawerId}"]`)) {
         $(`[data-search-condition-setting-drawer-id-for-desktop="${this.currentSearchConditionSettingDrawerId}"]`).css({
            display: 'none',
            opacity: 0,
            visibility: 'hidden',
         });

      }
      this.currentSearchConditionSettingDrawerId = '';
      // イベントのバインドを解除
      $(document).off('click.closeSearchConditionSettingDrawerForDesktop');
   }

   onClickSearchConditionSettingDrawerSetBtnForUses(e) {
      const $parent = this.windowWidth < BREAKPOINTS.MEDIUM ?
         $(e.currentTarget).closest('[data-search-condition-setting-drawer-id]') :
         $(e.currentTarget).closest('[data-search-condition-setting-drawer-id-for-desktop]');
      const $formItems = $('[data-search-condition-setting-drawer-form-item]', $parent);
      const checkedOptions = [];
      if ($formItems) {
         $formItems.each((i, el) => {
            const formName = $(el).attr('data-search-condition-setting-drawer-form-item');
            if (formName === 'uses[]') {
               // elがcheckboxの場合で、かつチェックされている場合
               if ($(el).prop('checked')) {
                  const value = $(el).val();
                  // NOTE: labelタグで囲まれていることを想定している
                  const text =  $(el).closest('label').find('[data-search-condition-setting-drawer-form-label]').text();
                  checkedOptions.push({ value: value, text: text });
               }
            }
         });
         let concatenatedTexts = '指定なし（飲食、美容室...などから選択）';
         // 既存のuses[]を削除（実際にpostされるhiddenフィールド）
         this.$fvSearchform.find('input[name="uses[]"][type="hidden"]').remove();
         // this.$fvSearchform.find('input[name="uses[]")のcheckedを解除
         this.$fvSearchform.find('input[name="uses[]"]').prop('checked', false);

         // TODO:UX的に外側クリックで閉じたときもこの処理しちゃってよさそう
         if (checkedOptions.length > 0) {
            // uses[]を再設定。hiddenフィールドをappendする
            checkedOptions.forEach((option) => {
               this.$fvSearchform.prepend(`<input type="hidden" name="uses[]" value="${option.value}">`);
            });
            // 用途業種のUIのテキストを処理しておく
            concatenatedTexts = checkedOptions.map(function(option) {
               return option.text;
            }).join(', ');
         }
         // UIのテキストを更新
         $('[data-search-condition-setting-text="uses"]').text(concatenatedTexts);
      }
      // close drawer ui
      if (this.currentSearchConditionSettingDrawerId) {
         // mobile
         if (this.windowWidth < BREAKPOINTS.MEDIUM) {
            this.closeSearchConditionSettingDrawer();
         } else {
            // desktop
            this.closeSearchConditionSettingDrawerForDesktop();
         }
      }
   }
};
